import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NormalOnboarding from './Normal';
import {
  saveNormalCarnival,
  getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
//   pocList: state.ConductCampReducer.pocList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  leadInfraId: state.ConductCampReducer.leadInfraId,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getLeadInfraId,
      saveNormalCarnival
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NormalOnboarding);
